import Component from './TikTokAnalyticsPublicHeader.vue'
export default Component
